import { preciseCurrencyFormatter } from '@shared/helpers/format-currency';
import type { Product } from '../../../data/product';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

export const CurrentCost: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Current Cost',
  minWidth: 85,
  accessorFn: (product) => {
    if (product.pricing.current_cost) {
      return preciseCurrencyFormatter(product.pricing.current_cost);
    }

    return '';
  },
  toCSV: (product) => ({
    'Current Cost': product.pricing.current_cost ? product.pricing.current_cost.toFixed(2) : '',
  }),
});
